import clsx from 'clsx';
import React from 'react';

import MyTISectionHeader from './SectionHeader';

const MyTISection = ({
  children,
  hasBorder = true,
  highlight,
  subtitle,
  title,
}: {
  children: React.ReactNode;
  hasBorder?: boolean;
  highlight: string;
  subtitle: string;
  title: string;
}) => {
  return (
    <article
      className={clsx(
        'mt-48 sm:mt-80',
        hasBorder && 'border-0 border-t border-solid border-grayscale-gray pt-48 sm:pt-80'
      )}
    >
      <MyTISectionHeader highlight={highlight} subtitle={subtitle} title={title} />
      {children}
    </article>
  );
};

export default MyTISection;
